import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookieConsent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, ts: new Date().toISOString() }));
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, ts: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
        <p className="text-sm text-gray-700 leading-relaxed">
          DuoFit używa magazynu przeglądarki (token logowania, preferencje) wymaganego do działania aplikacji. Nie używamy obecnie cookies analitycznych ani marketingowych.{" "}
          <Link to="/legal/cookies" className="text-blue-600 hover:underline whitespace-nowrap">Polityka Cookies</Link>{" · "}
          <Link to="/legal/privacy" className="text-blue-600 hover:underline whitespace-nowrap">Polityka Prywatności</Link>
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={reject}
            className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded hover:bg-gray-50"
          >
            Tylko niezbędne
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700"
          >
            Rozumiem
          </button>
        </div>
      </div>
    </div>
  );
}
